import React from 'react';
import { Button, Flex, Switch, Text } from '@contentful/f36-components';
import { DeleteIcon } from '@contentful/f36-icons';
import { TestIds } from '../fixtures/constants';
import { TagSelection } from '../model/ApplicationState';

interface TagValueSelectorProps {
  selectedTag: TagSelection;
  tagLabel: string;
  onSelectTagValue: (tagName: string, value: boolean) => void;
  onRemoveTag: (tagName: string) => void;
}

export const TagValueSelector = (props: TagValueSelectorProps): React.JSX.Element => {
  const isChecked = props.selectedTag.value === true;

  const handleToggle = () => {
    props.onSelectTagValue(props.selectedTag.name, !isChecked);
  };

  const handleRemoveTag = () => {
    props.onRemoveTag(props.selectedTag.name);
  };

  return (
    <Flex
      data-test-id={TestIds.TAG_VALUE}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      style={{ border: '1px solid var(--color-gray-300)', borderRadius: 'var(--border-radius-small, 6px)' }}
      padding="spacingXs"
      marginBottom="spacingS"
    >
      <Text fontSize="fontSizeL" fontWeight="fontWeightMedium" marginRight="spacingXs">
        {props.tagLabel}
      </Text>
      <Flex alignItems="center" gap="spacingS">
        <Text fontSize="fontSizeM" fontColor={!isChecked ? 'colorPositive' : 'colorNegative'}>
          False
        </Text>
        <Switch id={`tag-toggle-${props.selectedTag.name}`} isChecked={isChecked} onChange={handleToggle} />
        <Text fontSize="fontSizeM" fontColor={isChecked ? 'colorPositive' : 'colorNegative'}>
          True
        </Text>
        <Button variant="negative" size="small" startIcon={<DeleteIcon />} onClick={handleRemoveTag}>
          Remove
        </Button>
      </Flex>
    </Flex>
  );
};
